import React from "react";
import { RotaButton } from "@teamrota/rota-design";

import {
  Action,
  Actions,
  Dialog,
  Heading,
  Message,
  Overlay,
} from "../result/styles";

export const DangerZoneModal: React.FC<{
  isLoading?: boolean;
  onProceed: () => void;
  onCancel: () => void;
}> = ({ isLoading, onProceed, onCancel }) => {
  return (
    <Overlay onClick={onCancel}>
      <Dialog
        role="dialog"
        aria-modal="true"
        aria-label="Danger Zone confirmation"
        onClick={(event) => event.stopPropagation()}
      >
        <Heading style={{ color: "red" }}>⚠️ Danger Zone</Heading>

        <Message>
          Re-running algorithm over all streams can cause high resource use and
          should only be done at quiet times.
        </Message>

        <Actions>
          <Action>
            <RotaButton
              onClick={onCancel}
              disabled={isLoading}
              size="large"
              variant="outlined"
            >
              Cancel
            </RotaButton>
          </Action>

          <Action>
            <RotaButton
              onClick={onProceed}
              disabled={isLoading}
              size="large"
              variant="contained"
              isLoading={isLoading}
            >
              Proceed
            </RotaButton>
          </Action>
        </Actions>
      </Dialog>
    </Overlay>
  );
};
